import * as React from "react";
import { isMarketType, getDictPhrase, getUniqueClassName, createBsUtilMsgItem } from "../../../../../../helpers";
import { BetBtnRegular } from "../../../../components";
export const renderMiniBetButtonsRegular = (cardProps, market, componentPrefix) => {
    const marketUniqueClass = getUniqueClassName(market.id, "market");
    return (React.createElement("div", { key: `${componentPrefix}__${market.id}`, className: `rj-ev-list__${componentPrefix}__section rj-ev-list__${componentPrefix}__section--${market.template} ${marketUniqueClass}`, "data-uat": `div-ev-list-${componentPrefix}-section` }, market.selections && market.selections.map((s, index) => {
        const betslipModifier = s.isSelectionInBetslip ? "rj-ev-list__bet-btn--chosen" : "";
        const name = getSelectionName(cardProps, market, s);
        const selectionUniqueClass = getUniqueClassName(s.id, "selection");
        return (React.createElement(BetBtnRegular, { key: `${componentPrefix}__bet-btn__${market.id || "m"}-${s && s.id || "s"}-${index}`, isDisabled: s.isDisabled, classNames: `${betslipModifier} ${selectionUniqueClass}`, handler: () => cardProps.handlers.betButton(s.isSelectionInBetslip, [createBsUtilMsgItem(cardProps.event, market, s)]), text: name, point: s.pointsText, odd: s.odds, trueOdds: s.trueOdds, hideLowOdds: cardProps.hideLowOdds }));
    })));
};
export const getSelectionName = (cardProps, market, selection) => {
    if (isMarketType(market.marketType.id, "HC") && !cardProps.isDesktop) {
        return "";
    }
    if (isMarketType(market.marketType.id, "ML")
        && !cardProps.showMLTeamName
        && selection.outcomeType !== null) {
        return getDictPhrase(cardProps.dict, selection.outcomeType);
    }
    return selection.name;
};
//# sourceMappingURL=renderMiniBetButtonsRegular.js.map